<template>
  <div class="container-users">
    <el-container>
      <el-header height="15%">
        <h4>Пользователи</h4>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск" label-width="84px" label-position="left" >
          <el-row>
            <el-col :lg="12" :xl="6">
              <el-form-item label="Поиск">
                <el-col :span="14">
                  <input
                    type="text"
                    class="el-input__inner"
                    v-model="query.q"
                    ref="nameInput"
                    @change="setQueryReset"
                  />
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :xl="6">
              <el-form-item label="Фильтрация по роли">
                <el-col :span="14">
                  <el-select
                  v-model="query.roles"
                  clearable
                  multiple
                  @change="setQueryReset">
                    <el-option
                      v-for="(item, index) in userRoleConfig"
                      :key="index"
                      :value="item.field"
                      :label="item.title"
                    />                    
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :xl="6">
              <el-form-item label="Сортировка">
                <el-select
                  v-model="query.sort"
                  :width="300"
                  @change="setQuery"
                >
                  <el-option
                    v-for="(item, index) in sortConfig"
                    :key="index"
                    :value="item.field"
                    :label="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="users" style="width: 100%">
          <el-table-column prop="id" label="Id" width="50" />
          <el-table-column prop="payer_type" label="Тип" width="60">
            <template slot-scope="props">
              {{getHumanType(props.row.payer_type)}}
            </template>
          </el-table-column>
          <el-table-column label="Компания">
            <el-table-column prop="company"  type="expand">
              <template slot-scope="props">
                <el-row v-if="props.row.company" class="container-users__table-expand">
                  <el-row class="container-users__table-expand-row">
                    <el-col :span="2">
                      ИНН:
                    </el-col>
                    <el-col :span="18">
                      {{props.row.company.inn || '-'}}
                    </el-col>
                  </el-row>
                  <el-row class="container-users__table-expand-row">
                    <el-col :span="2">
                      КПП:
                    </el-col>
                    <el-col :span="18">
                      {{props.row.company.kpp || '-'}}
                    </el-col>
                  </el-row>
                  <el-row class="container-users__table-expand-row">
                    <el-col :span="2">
                      Адрес:
                    </el-col>
                    <el-col :span="18">
                      {{props.row.company.address || '-'}}
                    </el-col>
                  </el-row>
                </el-row>
                <el-row v-else class="container-users__table-expand">
                  <el-row class="container-users__table-expand-row">
                    <el-col :span="2">
                      ИНН:
                    </el-col>
                    <el-col :span="18">
                      {{props.row.inn || '-'}}
                    </el-col>
                  </el-row>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column prop="company.name" label="Название компании" />
          </el-table-column>
          <el-table-column label="Пользователь">
            <el-table-column prop="name" label="Имя" />
            <el-table-column prop="email" label="Почта" />
          </el-table-column>          
          <el-table-column fixed="right" label="Действия" width="120">
            <template slot-scope="props">
              <el-button
                size="mini"                
                @click="goToDetail(props.row.id)"
              >
              Изменить
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="paginator.total"
          :current-page.sync="paginator.current_page"
          @current-change="getPage(paginator.current_page)"
          :hide-on-single-page="true"
          :page-size="paginator.per_page"
          :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
    <update-role-user-dialog
      v-if="$store.getters.userRoleUpdateDialog"
    ></update-role-user-dialog>
  </div>
</template>

<script>
import axios from "axios";
import UpdateRoleUserDialog from "@/components/Users/UpdateRoleUserDialog";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import sortConfig from '../../composable/config/users-sort.config';
import userRoleConfig from '../../composable/config/user-role.config';
import userProfileTypeConfig from '../../composable/config/user-profile-type.config';

export default {
  name: "Users",
  components: {
    UpdateRoleUserDialog,
  },
  data: function () {
    return {
      status: 0,
      paginator: [],
      users: [],
      sortConfig,
      userRoleConfig,
      userProfileTypeConfig,
      query: {
        q: "",
        roles: [],
        sort: sortConfig[0].field,
        page: 1,
      },
      searchTimeout: null,
    };
  },
  computed: {
    activeSort() {
        const result = this.sortConfig.find((e) => e.field === this.query.sort)
        return result ? result.options  : undefined
    },
  },
    watch:{
    '$route.query'(v){   
      const query = this.getQuery(v)   
            if (query){              
                this.getUsers(query)
            }
        }
    },
  mounted() {
    this.initParams(this.$route.query);
    this.getUsers(this.getQuery(this.$route.query));
  },
  methods: {
    getUsers: function(query) {
      this.$store.commit(SETPRELOADER_STATE, true)
      axios.get('user'  + query).then((response)=>
          {
            this.users = response.data.data;
            this.paginator = response.data.meta;
          }
      ).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
      })
      .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    getPage: function(pageNum) {
      if(pageNum){
        this.query.page = pageNum
        this.setQuery()
      }
    },
    goToDetail: function (id){
      const path = `/user/${id}`
      this.$router.push(path);
    },
    getHumanType: (type) => {
      if (type) {
        const findResult = userProfileTypeConfig.find((e) => e.field === type)
        const findTitle = findResult?.title || '';
        if (findTitle !== '') {
          const result = findTitle.split(' ').map((e) => e[0]);
          return result.join('.');
        }
      }
      return "-"
    },

    setQueryReset(){
      this.query.page = 1
      this.setQuery()
    },
    setQuery(){
      const result = {};
      let isChange = false;
      
      if (this.activeSort) {
        isChange = true;
        result['sort']= {
            by: this.activeSort.by,
            order: this.activeSort.order
        }          
      }
      if (this.query.q) {
        isChange = true;
        result['q']=this.query.q
      }
      if(this.query.page){
        isChange = true
        result['page']=this.query.page
      }
      if(this.query.roles.length > 0){
        isChange = true
        result['roles']=this.query.roles
      }

      if (isChange) {
        const q = this.getQuery(result)
        this.$router.push({
          path: 'users' + q,
        })
      }
    }, 
    getQuery(query) {
      if (Object.keys(query).length > 0){        
        const qs = require('qs');
        return `?${qs.stringify(query)}`
      }
      return ''
    },
    initParams(query){
      if (!query){
        return
      }

      const qs = require('qs');
      const parseQuery= qs.parse(query);

      if (parseQuery.sort?.by && parseQuery.sort?.order) {
        this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
      }
      if (parseQuery.q){
        this.query.q = parseQuery.q
      }
      if(parseQuery.page){
        this.query.page= parseQuery.page
      }
      if(parseQuery.roles){
        this.query.roles = parseQuery.roles
      }
    }
  }
};
</script>

<style scoped>
.container-users__table-expand{
  padding: 0 24px;
}

.container-users__table-expand-row{
  margin-top: 12px;
}

.container-users__table-expand-row:first-child{
  margin-top: 0;
}
</style>